module.exports = __webpack_public_path__ + "public/Icons/Language-black.svg?5919ece0";